import { en } from "./en";

export const pt: typeof en = {
  languages: {
    de: "De",
    en: "En",
    zh: "中文",
    pt: "Pt",
    fr: "Fr",
  },
  seoDefaults: {
    albis: {
      title: "ALBIS - Fácil, Inteligente, apaixonado.",
      brandPrefix: "ALBIS - ",
      description:
        "Distribuição de polímeros. Especialistas técnicos e consultores para todos os assuntos relacionados com plásticos. Um dos portfólios mais amplos do mundo.",
    },
    mocom: {
      title: "MOCOM - Excelência em compostos.",
      brandPrefix: "MOCOM - ",
      description: "Composição de polímeros.",
    },
    krahnCeramics: {
      title:
        "KRAHN Ceramics - Parceiro de projeto inovador para processamento de pós cerâmicos e metálicos",
      brandPrefix: "KRAHN CERAMICS - ",
      description:
        "Como parceiro tecnológico experiente no campo da cerâmica e metais, acompanhamos desenvolvedores de produtos na realização das ideias de amanhã ao longo de toda a cadeia de valor: desde pós cerâmicos ou metálicos até à produção de peças acabadas.",
    },
    ottoKrahnGroup: {
      title: "Otto Krahn Group – Reinventado.",
      brandPrefix: "Otto Krahn Group - ",
      description:
        "O seu parceiro de confiança há 111 anos para plásticos e química tem uma nova estrutura: ALBIS, KRAHN, MOCOM, WIPAG unidos na nova empresa holding.",
    },
    htf: {
      title: "KRAHN Heat Transfer Fluids - Parceiro oficial da Eastman",
      brandPrefix: "KRAHN Heat Transfer Fluids - ",
      description:
        "Seleção do fluido de transferência de calor certo do portfólio Therminol®/Marlotherm™. Consultoria abrangente sobre aquecedores, bombas e tecnologias de ar de exaustão.",
    },
    wipag: {
      title: "WIPAG",
      brandPrefix: "WIPAG - ",
      description:
        "Especialista na produção de compostos através do processamento de plásticos, bem como na implementação de conceitos individuais de economia circular.",
    },
    plgrd: {
      title: "Playground",
      brandPrefix: "Playground - ",
      description: "Para brincar com o solo",
    },
    krahnChemie: {
      title: "KRAHN Chemie",
      brandPrefix: "KRAHN Chemie - ",
      description: "KRAHN Chemie",
    },
    okNewBusiness: {
      title: "Otto Krahn New Business",
      brandPrefix: "Otto Krahn New Business",
      description: "Otto Krahn New Business",
    },
  },
  header: {
    contact: "Contacto",
    outline: "Visão Geral",
  },
  search: {
    search: "Pesquisar",
    label: "Pesquisar",
    lastSearches: "As suas últimas pesquisas",
    directEnter: "Entrada direta",
    files: "Ficheiros",
    stories: "Artigos",
    pages: "Páginas",
    products: "Produtos",
    press: "Comunicado de Imprensa",
    industries: "Indústrias",
    results: "resultados para",
    more: "mostrar mais",
    noResults: "Não há resultados para",
    adjustSearch: "Por favor ajuste a sua pesquisa e tente novamente.",
    download: "Descarregar",
    short: "O seu termo de pesquisa é muito curto.",
    entrances: {
      albis: [
        {
          link: "/pt/products/product-search/",
          label: "Fichas Técnicas",
        },
        {
          link: "/pt/services/quality-management",
          label: "Certificados",
        },
        {
          link: "/pt/products/brochures",
          label: "Fichas de Dados de Segurança",
        },
      ],
      wipag: [
        {
          link: "/pt/downloads",
          label: "Downloads e Certificados",
        },
      ],
      mocom: [
        {
          link: "/pt/products/product-search#/",
          label: "Fichas Técnicas",
        },
        {
          link: "/pt/downloads",
          label: "Fichas de Dados de Segurança e Certificados",
        },
      ],
      ottoKrahnGroup: [{ link: "/pt/brands", label: "Marcas" }],
      krahnChemie: [{ link: "/pt/markets", label: "Mercados" }],
    },
  },
  products: {
    viewProduct: "Ver o produto",
    back: "Voltar à visão geral",
  },
  newsletter: {
    mandatory: "* campo obrigatório",
  },
  contact: {
    phone: "Telefone:",
    fax: "Fax:",
    email: "E-mail:",
    writeEMail: "Escrever um E-mail",
    form: {
      button: "Submeter",
      send: "Enviar",
      placeholder: {
        email: "E-mail",
        name: "Nome",
        company: "Empresa (opcional)",
        companyReq: "Empresa",
        subject: "Assunto",
        street: "Rua",
        apartmentNumber: "Número da casa",
        plz: "Código postal",
        city: "Cidade",
        message: "Descreva o seu desafio:",
        country: "País",
        startup: "Empresa",
        comment: "Comentário",
        phone: "Telefone",
      },
      label: {
        message: "A sua mensagem",
      },
      success: "Obrigado! A sua mensagem foi enviada.",
      error:
        "Ocorreu um erro. Tente novamente mais tarde ou contacte-nos via info@albis.com.",
    },
  },
  contactFinder: {
    title: "O Seu Contacto",
    description:
      "Para o ajudarmos a responder melhor às suas questões, insira aqui a sua localização e código postal. A pessoa de contacto apropriada será então exibida.",
    findAction: "Encontrar",
    zipCodeLabel: "Código postal",
    countryLabel: "Escolher país",
    contactPersonTitle: "Pessoa de Contacto",
    warningMessage:
      "Infelizmente, não conseguimos encontrar uma pessoa de contacto. Verifique a sua inserção de país e código postal.",
    contactButton: "Pedir Contacto",
  },
  contactFinderV2: {
    countryLabel: "Escolher país",
    loadingText: "A carregar...",
  },
  contactDialog: {
    title: "Pedir contacto",
    contactByPhoneActionLabel:
      "Por favor ligue-me de volta para o seguinte número de telefone:",
    dataProtectionConsentActionLabel:
      "Concordo com a <a href='https://www.albis.com/pt/privacy' target='_blank'>política de proteção de dados</a>.",
    requestMsgLabel: "Diga-nos o motivo do seu pedido",
    submit: "Enviar Mensagem",
    requestMessage: "Inserir aqui",
    successTitle: "Entraremos em contacto consigo",
    successDescription:
      "O seu pedido foi submetido com sucesso. Entraremos em contacto consigo o mais rapidamente possível.",
    errorDescription: "Algo correu mal.",
    successBtnLabel: "Voltar à página",
  },
  media: {
    press: {
      categories: {
        products: "Produtos",
        company: "Empresa",
        "shows-and-events": "Feiras e Eventos",
        "healthcare-solutions": "Soluções de Saúde",
        extrusion: "Extrusão",
        "smart-plastics-at-home": "Plásticos inteligentes@casa",
        sustainability: "Sustentabilidade",
        "markets-industry": "Mercados / Indústria",
        "success-story": "Caso de Sucesso",
        "expert-article": "Artigo de Especialista",
        events: "Eventos",
      },
      loadMore: "Carregar mais",
    },
    events: {
      addToCalendar: "Adicionar ao calendário",
    },
    filter: {
      year: "Ano de lançamento",
      topic: "Tópico",
    },
    noResults: "Sem entradas",
  },
  markets: {
    cases: "Estudos de Caso",
    productInformation: "Informação do Produto",
    categories: {
      interior: "Interior",
      exterior: "Exterior",
      "under-the-hood": "Debaixo do capô",
      outdoor: "Ferramentas de Jardim",
      hvac: "Aquecimento, Ventilação, Ar Condicionado",
      furniture: "Mobiliário",
      kitchenware: "Pequenos Eletrodomésticos e Utensílios Domésticos",
      sanitary: "Sanitário",
      tools: "Ferramentas Elétricas",
      wintersports: "Desportos de Montanha e Inverno",
      sportswear: "Roupa Desportiva",
      marine: "Desportos Aquáticos",
      materials: "Materiais",
      vehicles: "Veículos",
      trains: "Comboios",
      digger: "Escavadora",
      solar: "Energias Renováveis",
      radio: "Rádio",
      video: "Sistemas de Segurança",
      computer: "Grandes Eletrodomésticos",
      lights: "Tecnologia de Iluminação",
      electricity: "Instalação Elétrica",
      machine: "Máquinas",
      robots: "Robôs",
      aircondition: "Ar Condicionado",
      safety: "Segurança",
      monitors: "Monitores",
      controlling: "Controlo",
      tubes: "Tubos",
      bedside: "Materiais de cabeceira",
      packaging: "Embalagem",
      bicycle: "Desportos de Bicicleta",
      household: "Ajudas domésticas",
      "post-industrial": "Reciclagem pós-industrial",
      renewable: "Energias renováveis",
      mechanical: "Reciclagem mecânica",
      energy: "Reciclagem energética",
      biobased: "Recursos de base biológica",
      "post-consumer": "Reciclagem pós-consumo",
      diagnostic: "Diagnóstico in vitro, material de laboratório e biociência",
      infusion: "Dispositivos Médicos - Sistemas de infusão",
      "drug-delivery":
        "Dispositivos Médicos - Sistemas de administração de medicamentos",
      monitoring:
        "Dispositivos Médicos - Terapia intensiva e monitorização de pacientes",
      "medical-packaging":
        "Embalagem de produtos farmacêuticos e dispositivos médicos",
      "medical-devices":
        "Outros dispositivos médicos - área de aplicação cirurgia, reabilitação, doação de sangue, vacinação (exemplos)",
    },
  },
  okg: {
    jobTeaser: {
      student: "Estudantes",
      graduate: "Licenciados",
      youngprofessional: "Jovens Profissionais",
      professional: "Profissionais",
    },
    pressTeaser: {
      news: "Notícias",
      readMore: "Artigo completo",
    },
    privacy: "Política de privacidade",
  },
  htf: {
    tempRange: "Gama de temperatura:",
    modeDetails: "mais detalhes",
    close: "fechar",
    searchPlaceholder: "Pesquisar produto",
    typicalApplication: "Aplicações Típicas",
    descriptionOfServices: "Descrição de serviços",
    productData: "Dados do Produto",
    thermometerDescription:
      "Por favor mova os reguladores para filtrar os produtos.",
    thermometerMinLabel: "Temperatura mín. (°C)",
    thermometerMaxLabel: "Temperatura máx. (°C)",
    resetFilter: "Repor Filtro",
    filter: "Filtro",
    tempRangeFormat: "#t1#° a #t2#°C",
    productInformation: {
      tempRange: "Gama de temperatura",
      optimalUsageTemp: "Uso ideal da temperatura",
      maxBulkTemp: "Temperatura a granel recomendada °C",
      maxExtendedBulkTemp: "Temperatura a granel máx. estendida °C",
      maxFilmTemp: "Temperatura de filme máx. °C",
      boilingPoint: "Ponto de ebulição °C @ 1013 mbar",
      pumpability: "Bombeabilidade °C @ 300 mm²/s (cSt)",
      pourPoint: "Ponto de Derramamento °C",
      crystallizingPoint: "Ponto de Cristalização °C",
      slurryPoint: "Ponto de Lama °C",
      flashPointD93: "Ponto de Inflamação °C (ASTM D93)",
      flashPointD92: "Ponto de Inflamação °C (ASTM D92)",
      autoignitionTempDIN51794: "Temperatura de Auto-ignição °C (DIN 51794)",
      autoignitionTempASTME659: "Temperatura de Auto-ignição °C (ASTM E-659)",
      density20: "Densidade @ 20°C (kg/m³)",
      density25: "Densidade @ 25°C (kg/m³)",
      density80: "Densidade @ 80°C (kg/m³)",
      kinematicViscosity25: "Viscosidade cinemática @ 25°C (mm²/s)",
      kinematicViscosity40: "Viscosidade cinemática @ 40°C (mm²/s)",
      kinematicViscosity80: "Viscosidade cinemática @ 80°C (mm²/s)",
      waterClass: "Classe de Água",
      approval: "Aprovação",
    },
    pTypicalApplication: {
      "product-ta-oil": "Processamento de Petróleo e Gás",
      "product-ta-ng-purification": "Purificação de Gás Natural",
      "product-ta-refining": "Refinação",
      "product-ta-aps": "Processamento e Armazenamento de Asfalto",
      "product-ta-gtl": "Gás para Líquido (GTL)",
      "product-ta-pp-manufacturing": "Fabrico de Plásticos e Polímeros",
      "product-ta-shp-manufacturing":
        "Fabrico de Polímeros Especiais Sensíveis ao Calor",
      "product-ta-sfm": "Fabrico de Fibras Sintéticas",
      "product-ta-plastic-molding": "Moldagem de Plástico",
      "product-ta-pharmaceutical-manufacturing": "Fabrico Farmacêutico",
      "product-ta-chiral-chemical-processes": "Processos Químicos Quirais",
      "product-ta-environmental-test-chambers": "Câmaras de Teste Ambiental",
      "product-ta-specialty-chemical-manufacturing":
        "Fabrico de Químicos Especiais",
      "product-ta-chemical-manufacturing": "Fabrico Químico",
      "product-ta-concentrated-solar-power": "Energia Solar Concentrada",
      "product-ta-orc": "Ciclo Orgânico de Rankine (ORC)",
      "product-ta-biofuel": "Fabrico de Biocombustível",
      "product-ta-foodbeverage-processing":
        "Processamento de Alimentos e Bebidas",
      "product-ta-mdf": "Placa de Fibra de Densidade Média (MDF)",
      "product-ta-desalination": "Dessalinização",
      "product-ta-htsm": "Manutenção de Sistema de Transferência de Calor",
    },
    checkboxHeadline: "Escolher aplicação",
    tempRangeHeadline: "Gama de temperatura °C",
    checkboxFilterLabels: {
      heatingAndRecovery: "Aquecimento/recuperação de calor",
      heatingAndCooling: "Aquecimento/arrefecimento",
      cooling: "Arrefecimento",
      thermoRegulation: "Termorregulação",
      foodgrade: "Grau alimentar",
    },
    noProductsFound:
      "Não conseguimos encontrar produtos que correspondam aos seus critérios.",
    wrongProductId: {
      title: "Produto não encontrado",
      text:
        "Não conseguimos encontrar produtos que correspondam aos seus critérios.",
      cta: "Para visão geral",
    },
    contactHeader: {
      slogan: "Soluções de óleo térmico em que pode confiar.",
      contactUs: "Fale com a nossa equipa",
      phone: "+31 75 70010 15",
      mail: "htf@krahn.eu",
    },
    globalContactForm: {
      headline: "Encontre a sua solução de óleo térmico hoje!",
      talkToUs: "Contacte-nos agora",
      mail: "E-mail",
      phone: "Telefone",
      askForCallback: "Enviar Pedido",
      dropDownDefault: "Como podemos ajudá-lo?",
      dropDown: {
        technicalConsultation: "Pedido de consultoria técnica",
        requestSample: "Pedido de amostra de óleo",
        requestOffer: "Pedido de oferta",
        requestCallback: "Pedido de retorno de chamada",
      },
      success: "Obrigado! A sua mensagem foi enviada com sucesso.",
      error: "Ocorreu um erro. Tente novamente mais tarde.",
    },
    readMore: "Ler mais",
  },
  krahnCeramics: {
    openImage: "Abrir Imagem",
  },
  krahnChemie: {
    contact: {
      form: {
        placeholder: {
          message: "Insira a sua mensagem",
        },
      },
    },
  },
  scroll: "Deslizar para descobrir",
  brochure: "Brochuras",
  productInformation: "Informação do produto",
  innovationChallenge: {
    jobs: {
      student: "Estudante",
      startUpStaff:
        "Funcionário de uma Startup interessado em juntar-se ao desafio",
      universityStaff:
        "Investigador/Pessoal científico numa universidade, faculdade, instituto ou instituição comparável",
    },
  },
  redirect: {
    title: "Ocorreu um erro.",
    text: "Queria dizer {{}}?",
    buttonLabel: "Para página correta",
  },
  pageNotFound: {
    title: "Esta página não foi encontrada (404)",
    text: "Esta página não foi encontrada, por favor volte atrás.",
    buttonLabel: "Voltar",
  },
  clientArea: {
    successMessage: "O seu pedido foi enviado com sucesso.",
    errorMessage:
      "Algo correu mal. Tente novamente e verifique os dados inseridos.",
    titleOrder: "O Seu Pedido Nº: ",
    titleAlbisNr: "O Seu Pedido Albis Nº: ",
    materialName: "Nome do Material",
    materialNumber: "Nº do Material",
    dataSource: "Ficha Técnica",
    sdb: "FDS",
    apz: "COA",
    orderNr: "Nº Pedido",
    orderNrLong: "Número do Pedido",
    albisNr: "Nº Pedido",
    date: "Data",
    name: "Nome",
    documentLabel: "Documento",
    backToOverview: "Voltar ao histórico de pedidos",
    contactBoxTitle: "O Seu Contacto",
    contactBoxAction: "Pedir retorno de chamada",
    orderInsight: {
      orderConfirmation: "Confirmação do Pedido",
      orderNumberLabel: "O Seu Pedido Nº: ",
      safetySheetLabel: "Ficha de Dados de Segurança",
      status: "Estado: ",
      estDeliveryDate: "Data de Entrega Estimada",
      materialQuantity: "Quantidade de Material",
      deliveryDocs: "Documentos do Pedido",
      albisDeliveries: "Entregas Albis",
    },
    albisOrderInsight: {
      partOfOrder: "O Seu Pedido Nº:",
      showOrder: "Mostrar pedido",
      materialName: "Nome do Material",
      materialNumber: "Nº do Material",
      amount: "Quantidade",
      chargeId: "Nº do lote",
      materials: "Materiais",
    },
    productOrderDialog: {
      title: "Reencomendar Produto",
      description:
        "Se gostaria de encomendar este produto novamente, complete o formulário abaixo e o colega relevante da Albis entrará em contacto consigo.",
      placeholder: {
        company: "Empresa",
        useCase: "Aplicação (opcional)",
        useCase2: "Aplicação",
        technicalRequirements: "Requisitos Técnicos (opcional)",
        technicalRequirements2: "Requisitos Técnicos",
        volume: "Volume",
        enterHere: "Por favor insira",
        color: "Cor",
        product: "Produto",
      },
      phoneRecallLabel:
        "Por favor ligue-me de volta usando o número fornecido.",
      moreProductsLabel: "Estou interessado em produtos adicionais.",
      productNameLabel: "Produto Selecionado: ",
      notesLabel: "Comentários adicionais",
      fileUploadLabel: "Carregar um documento",
      submitBtnLabel: "Enviar pedido",
    },
    productRequestDialog: {
      title: "Que tipo de produto está a procurar?",
      description:
        "Incerto sobre o material certo para a sua aplicação. Preencha o formulário abaixo e deixe os nossos especialistas ajudá-lo na sua decisão.",
    },
    filter: {
      timeRange: "Selecionar período de tempo de entrega",
      refresh: "Atualizar",
    },
    sdbHint: "FDS significa Fichas de Dados de Segurança",
    apzHint: "COA significa",
    login: {
      title: "Login",
      form: {
        mail: "E-mail*",
        customerNr: "Nº Cliente*",
        orderNr: "Nº Pedido (opcional)",
        hint:
          "Ao inserir o seu número de pedido, pode ir diretamente ao pedido.",
      },
      stayLoggedIn: "Manter-me ligado",
      modal: {
        headline: "Recebeu um E-mail",
        text:
          "Enviamos-lhe uma ligação mágica para o seu endereço de e-mail. Se abrir a ligação, será direcionado para a página de visão geral do pedido.",
      },
    },
    downloadsHint: "Download de Documentos estará disponível em breve",
    orderDownloadsHint: {
      label: "O download do documento não está atualmente disponível.",
      link: "Em alternativa, contacte-nos.",
    },
    moreOrders: "Pedidos abertos adicionais",
    openOrder: "Pedido Aberto",
    error: {
      title: "Ocorreu um erro.",
      albisIdText:
        "Não conseguimos encontrar nada sob este número de pedido Albis. Verifique a sua entrada.",
      orderIdText:
        "Não conseguimos encontrar nada sob este número de pedido Albis. Verifique a sua entrada.",
    },
    upload: {
      title: "Carregar um documento",
      success: "foi carregado com sucesso.",
      hint: "Eliminar ficheiro",
      error:
        "O carregamento do ficheiro não foi bem-sucedido. Tente novamente.",
    },
    startCall: {
      title: "Entre em contacto...",
      text:
        "Se está interessado em mais informações sobre o seu produto escolhido, complete o formulário abaixo e os nossos especialistas entrarão em contacto consigo para discutir.",
      productAdornment: "Produto: ",
    },
    states: {
      ordered: "Encomendado",
      confirmed: "Confirmado",
      scheduled: "Agendado",
      shipped: "Enviado",
      delivered: "Entregue",
      unknown: "Desconhecido",
      inProgress: "Em Progresso",
    },
  },
  recyclingForm: {
    polymer: "Polímero",
    mold: "Molde",
    filler: "Enchimento",
    color: "Cor",
    amount: "Quantidade em kg",
    description: "Descrição",
    adhesion: "Outra adesão",
    moreInfo: "Informação Adicional",
    wasteDescription: "Descrição do resíduo",
    quantityPerYear: "Quantidade gerada por ano (t/a)",
    currentUse: "Uso atual (venda/eliminação)",
    targetCustomer: "Alvo",
    closedLoop: "Ciclo fechado",
    openLoop: "Ciclo aberto",
    requirementsForFinishedProduct: "Requisitos para o produto acabado",
    additionalInfo: "Informação adicional, por exemplo tempo de funcionamento",
    personalInfo: "A sua informação",
    name: "Nome, Apelido",
    address: "Morada",
    email: "E-mail",
    phone: "Telefone",
    message: "Insira uma mensagem aqui",
    submit: "Submeter formulário",
    save: "Guardar",
    delete: "Eliminar",
    add: "Adicionar mais resíduos",
    success: "Obrigado! A sua mensagem foi enviada.",
    errorMocom:
      "Ocorreu um erro. Tente novamente mais tarde ou contacte-nos via info@mocom.eu.",
    error:
      "Ocorreu um erro. Tente novamente mais tarde ou contacte-nos via info@wipag.com.",
    notSaved: "Ainda não guardado",
    tooltips: {
      wasteDescription: {
        heading: "Informação necessária:",
        text:
          "Aplicação (geração de resíduos)\nPlásticos contidos e impurezas/adesões, revestimento existente (por exemplo, tinta)\nTipo e conteúdo de enchimento: por exemplo, fibra de vidro, talco, carbono em %\nCondição: Componentes, aparas, resíduos de perfuração, canais de alimentação, material triturado, material regranulado, etc.",
      },
      targetCustomer:
        "Ciclo fechado = material é devolvido aos clientes (fração alvo)\nCiclo aberto = assunção de resíduos para reciclagem e vendas",
      requirementsForFinishedProduct: {
        heading: "Questões:",
        text:
          "Requisitos regulamentares (por exemplo: FDA/UL/NSF/GMP/Médico), listagens\nEspecificação (por exemplo: propriedades mecânicas ou reológicas, cor)",
      },
    },
  },
  floatingButtonWipag: "Compra de Plásticos",
  regions: {
    de: "Alemanha",
    at: "Áustria",
    ch: "Suíça",
    uk: "Reino Unido",
    ie: "Irlanda",
    pl: "Polónia",
    ro: "Roménia",
    cz: "República Checa",
    hu: "Hungria",
    sk: "Eslováquia",
    be: "Bélgica",
    nl: "Países Baixos",
    lu: "Luxemburgo",
    it: "Itália",
    fr: "França",
    es: "Espanha",
    cn: "China",
    gr: "Grécia",
    il: "Israel",
    ru: "Rússia",
    se: "Suécia",
    no: "Noruega",
    fi: "Finlândia",
    dk: "Dinamarca",
    is: "Islândia",
    bg: "Bulgária",
    lv: "Letónia",
    ee: "Estónia",
    lt: "Lituânia",
    ba: "Bósnia-Herzegovina",
    hr: "Croácia",
    me: "Montenegro",
    mk: "Macedónia",
    si: "Eslovénia",
    rs: "Sérvia",
    cy: "Chipre",
    li: "Liechtenstein",
    pt: "Portugal",
    xk: "Kosovo",
    ua: "Ucrânia",
  },
  productArea: {
    selectRegion: "Veja o que está disponível na sua região",
    filterApplication: "Filtrar por Aplicações",
    filterSolution: "Filtrar por Soluções",
    filterIdea: "Filtrar por Ideias",
    filterManufacturer: "Filtrar por Fabricante",
    filterLubricants: "Filtrar por Lubrificantes",
    filterFuels: "Filtrar por Combustíveis",
    industry: "Selecionar indústria",
    contact: "Contacto",
    contactButton: "Detalhes de Contacto",
    back: "Voltar à visão geral",
    characteristics: "Características do Produto",
    brands: "Marcas",
    producer: "Produtor",
    application: "Aplicação",
    ideas: "Ideias",
    lubricants: "Lubrificantes",
    fuels: "Combustíveis",
    manufacturer: "Fabricante",
    availability: "Disponível em",
    search: "Pesquisar por nome do produto",
    searchResults: "Resultados para:",
    showAllProducts: "Mostrar todos os grupos de produtos de {{}}",
    noResults: "Nenhum resultado encontrado",
    noContentMaintained:
      "Parece não haver conteúdo nesta indústria. Volte mais tarde!",
    resetFilter: "Repor filtro",
    allCountries: "Escolha o seu País",
  },
  jobpages: {
    applyNow: "Candidate-se já!",
    bePartOfTeam: "Junte-se à nossa equipa como:",
    tasks: {
      title: "As suas tarefas",
      main: "Tarefas principais",
      additional: "Outras tarefas",
    },
    profile: {
      title: "O Seu Perfil",
      skills: "Experiência e conhecimento",
      personality: "Personalidade",
    },
    offers: "Ofertas no mercado de trabalho",
    showOffers: "Mostrar {{}} empregos",
    selection: "A sua seleção",
    filterArea: {
      freeText: "Palavras-chave",
      freeTextPlaceholder: "Palavra-chave, ID do Emprego",
      department: "Função",
      fallbackDepartment: "Todas as funções",
      location: "Localização",
      fallbackLocation: "Todas as localizações",
      level: "Nível de entrada",
      fallbackLevel: "Todos os níveis de entrada",
      company: "Divisão",
      fallbackCompany: "Todas as divisões",
    },
    contract: {
      limited: "temporário",
      unlimited: "permanente",
    },
    level: {
      starter: "Iniciantes no Emprego",
      professional: "Profissionais",
      students: "Estudantes",
      graduate: "Licenciados",
    },
    pagesPerPage: "Empregos por página",
    error: {
      jobDetail:
        "Ocorreu um erro ao carregar os detalhes do emprego. Tente novamente mais tarde.",
      jobboard:
        "Ocorreu um erro ao carregar as ofertas de emprego. Tente novamente mais tarde.",
    },
    sortingLabel: "Ordenar por",
    sortingOptions: {
      companyAsc: "Empresas ascendente",
      companyDesc: "Empresas descendente",
      titleAsc: "Título do emprego ascendente",
      titleDesc: "Título do emprego descendente",
      startOfWorkAsc: "Início do trabalho ascendente",
      startOfWorkDesc: "Início do trabalho descendente",
      locationAsc: "Localização ascendente",
      locationDesc: "Localização descendente",
    },
    departments: {
      finance: "Finanças, Contabilidade e Controlo",
      customerService: "Atendimento ao Cliente",
      graphics: "Design Gráfico e Arquitetura",
      distribution: "Vendas e Comércio",
      management: "Gestão e Desenvolvimento Corporativo",
      it: "TI e Desenvolvimento de Software",
      law: "Direito",
      purchase: "Compras, Gestão de Materiais e Logística",
      marketing: "Marketing e Publicidade",
      others: "Outras Disciplinas",
      projectManagement: "Gestão de Projetos",
      production: "Produção e Fabrico",
      pr: "RP e Jornalismo",
      processPlanning: "Planeamento de Processos e QA",
      teaching: "Ensino, I&D",
      health: "Saúde, Médico e Social",
      consulting: "Consultoria",
      administration: "Administração",
      engineering: "Engenharia e Técnico",
      hr: "RH",
      productManagement: "Gestão de Produtos",
      analysis: "Análise e estatísticas",
    },
    errorDetails: {
      title: "Emprego não foi encontrado",
      text:
        "Infelizmente, o anúncio de emprego solicitado já não existe. Execute uma nova pesquisa.",
      buttonLabel: "Voltar",
    },
    errorJobboard: {
      title: "Ocorreu um erro",
      text:
        "O carregamento das ofertas de emprego falhou. Tente novamente mais tarde.",
      buttonLabel: "Tentar novamente",
    },
    noJobsFound: {
      title: "Desculpe, a sua pesquisa não devolveu resultados.",
      text: "Altere os seus critérios e tente novamente.",
    },
    position: {
      fulltime: "Tempo completo",
      parttime: "Meio tempo",
      intern: "Estágio",
      freelance: "Freelancer",
      owner: "Proprietário",
      partner: "Parceiro",
      board: "Membro do Conselho de Supervisão",
      honorary: "Posição honorária",
      partFull: "Meio tempo / Tempo completo",
      trainee: "Formação",
      help: "Ajuda temporária",
      social: "Compromisso social",
      apprentice: "Aprendizagem",
      training: "Aprendizagem",
      marginal: "Marginal",
      student: "Estudante trabalhador",
      temp: "Temporário / Sazonal",
      dual: "Estudo duplo",
    },
  },
  a11y: {
    showContent: "Ativar para mostrar conteúdo para {{}}",
  },
  altcha: {
    bot: "Não sou um robô.",
    error: "Algo correu mal. Confirme que não é um robô.",
    verified: "Está verificado.",
    waitAlert: "Aguarde um momento.",
    verifying: "Verificação em progresso...",
    expired: "A sua verificação expirou. Tente novamente.",
  },
};
